import Format from './format';
import ajax from './ajax';

class Get {

  constructor() {
    this.format = new Format();
  }

  async address(cep) {
    return ajax.post({
      product: 'platform',
      category: 'core',
      domain: 'core',
      module: 'api',
      method: 'getAddress',
      body: { cep },
    });
  }


  banks(bank = null) {
    return ajax.post({
      product: 'platform',
      category: 'core',
      domain: 'core',
      module: 'api',
      method: 'getBank',
      body: { bank },
    });
  }

  city(uf) {
    return this.#getByFetch(`https://brasilapi.com.br/api/ibge/municipios/v1/${uf}?providers=dados-abertos-br,gov,wikipedia`);
  }

  cnpj(cnpj) {
    return ajax.post({
      product: 'platform',
      category: 'core',
      domain: 'core',
      module: 'api',
      method: 'getCompanyInfo',
      body: { cnpj },
    });
  }

  exchange(currency, date) {
    let url;

    if (currency) {
      if (!date) {
        const today = new Date();
        date = this.format.dateDB(today);
      }

      url = `https://brasilapi.com.br/api/cambio/v1/cotacao/${currency}/${date}`
    } else {
      url = 'https://brasilapi.com.br/api/cambio/v1/moedas';
    }

    return this.#getByFetch(url);
  }

  icon_type_options(){
    return [
      {value: 'solid', label: dic.icon_types.solid},
      {value: 'regular', label: dic.icon_types.regular},
      {value: 'light', label: dic.icon_types.light},
      {value: 'brands', label: dic.icon_types.brands},
      {value: 'duotone', label: dic.icon_types.duotone},
    ];
  }

  isbn(isbn) {
    return this.#getByFetch(`https://brasilapi.com.br/api/isbn/v1/${isbn}`);
  }

  get ip() {
    return this.#getByFetch('https://ipinfo.io/json');
  }

  /**
   * Retorna a GeoLocalização
   * 
   * @returns {object}
   */
  get geolocation() {
    let success = function (pos) {
      let coords = {
        accuracy: pos.coords.accuracy,
        altitude: pos.coords.altitude,
        altitudeAccuracy: pos.coords.altitudeAccuracy,
        latitude: pos.coords.latitude,
        longitude: pos.coords.longitude
      };
      sessionStorage.setItem('geolocation', JSON.stringify(coords));
    };

    let error = function (err) {
      console.error(true, 'ERROR(' + err.code + '):', err.message);
    };

    let options = {
      enableHighAccuracy: false,
      timeout: 10000,
      maximumAge: 0
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(success, error, options);
      let geolocation = JSON.parse(sessionStorage.getItem('geolocation'))
      sessionStorage.removeItem('geolocation');
      return geolocation;
    } else {
      return 'Localização não encontrada'
    }
  }

  /**
   * Retorna a tecla pressionada
   * 
   * @param {event} e
   * @returns {string}
   */
  key(e) {
    switch (e.keyCode) {
      case 8: return 'backspace';
      case 9: return 'tab';
      case 13: return 'enter';
      case 16: return 'shift';
      case 17: return 'ctrl';
      case 18: return 'alt';
      case 19: return 'pause';
      case 20: return 'caps';
      case 27: return 'esc';
      case 32: return 'space';
      case 33: return 'pageup';
      case 34: return 'pagedown';
      case 35: return 'end';
      case 36: return 'home';
      case 37: return 'left';
      case 38: return 'up';
      case 39: return 'right';
      case 40: return 'down';
      case 45: return 'insert';
      case 46: return 'delete';
      case 48: return '0';
      case 49: return '1';
      case 50: return '2';
      case 51: return '3';
      case 52: return '4';
      case 53: return '5';
      case 54: return '6';
      case 55: return '7';
      case 56: return '8';
      case 57: return '9';
      case 65: return 'a';
      case 66: return 'b';
      case 67: return 'c';
      case 68: return 'd';
      case 69: return 'e';
      case 70: return 'f';
      case 71: return 'g';
      case 72: return 'h';
      case 73: return 'i';
      case 74: return 'j';
      case 75: return 'k';
      case 76: return 'l';
      case 77: return 'm';
      case 78: return 'n';
      case 79: return 'o';
      case 80: return 'p';
      case 81: return 'q';
      case 82: return 'r';
      case 83: return 's';
      case 84: return 't';
      case 85: return 'u';
      case 86: return 'v';
      case 87: return 'w';
      case 88: return 'x';
      case 89: return 'y';
      case 90: return 'z';
      case 91: return 'winleft';
      case 92: return 'winright';
      case 93: return 'menulist';
      case 96: return 'pad0';
      case 97: return 'pad1';
      case 98: return 'pad2';
      case 99: return 'pad3';
      case 100: return 'pad4';
      case 101: return 'pad5';
      case 102: return 'pad6';
      case 103: return 'pad7';
      case 104: return 'pad8';
      case 105: return 'pad9';
      case 106: return 'pad*';
      case 107: return 'pad+';
      case 109: return 'pad-';
      case 110: return 'pad,';
      case 111: return 'pad/';
      case 112: return 'f1';
      case 113: return 'f2';
      case 114: return 'f3';
      case 115: return 'f4';
      case 116: return 'f5';
      case 117: return 'f6';
      case 118: return 'f7';
      case 119: return 'f8';
      case 120: return 'f9';
      case 121: return 'f10';
      case 122: return 'f11';
      case 123: return 'f12';
      case 144: return 'num';
      case 145: return 'scroll';
      case 188: return ',';
      case 190: return '.';
      case 191: return ';';
      case 192: return "'";
      case 193: return '/';
      case 194: return 'pad.';
      case 219: return '�';
      case 220: return ']';
      case 221: return '[';
      case 222: return '~';
      case 226: return '\\';
    }
  }

  /**
   * Retorna o navegador
   * 
   * @returns {string}
   */
  get navigator() {
    if (/firefox/i.test(navigator.userAgent)) {
      return 'Firefox';
    } else if (/opera/i.test(navigator.userAgent)) {
      return 'Opera';
    } else if (/edge/i.test(navigator.userAgent)) {
      return 'Edge';
    } else if (/chrome/i.test(navigator.userAgent)) {
      return 'Chrome';
    } else if (/safari/i.test(navigator.userAgent)) {
      return 'Safari';
    } else if (/.net/i.test(navigator.userAgent)) {
      return 'IE';
    } else {
      return 'Other';
    }
  }

  /**
   * Retorna um item do path
   * 
   * @param {string} key
   * @returns {mixed}
   */
  pathKey(key) {
    return location.pathname.replace(/^\//, '').split('/')[key];
  }

  /**
   * Retorna a plataforma
   * 
   * @returns {string}
   */
  get platform() {
    if (/linux/i.test(navigator.platform)) {
      return 'Linux';
    } else if (/mac/i.test(navigator.platform)) {
      return 'Mac';
    } else if (/win/i.test(navigator.platform)) {
      return 'Windows';
    } else {
      return 'Other';
    }
  }

  /**
   * Retorna a querystring
   * 
   * @returns {string}
   */
  get queryString() {
    let query = location.href;
    query = query.split('?');
    return decodeURI(query[1]);
  }

  rates(rate = null) {
    const url = ('https://brasilapi.com.br/api/taxas/v1') + (rate ? `/${rate}` : '');
    return this.#getByFetch(url);
  }

  get uf() {
    return this.#getByFetch('https://brasilapi.com.br/api/ibge/uf/v1');
  }

  /**
 * Recupera a variável get da URL
 * 
 * @returns {object}
 */
  get vars() {
    let tmp = location.href;
    tmp = tmp.split('?')[1];
    if (tmp !== undefined) {
      tmp = tmp.split('&');
      let get = {};

      for (let i in tmp) {
        let tmp2 = tmp[i].split('=');
        get[tmp2[0]] = tmp2[1];
      }
      return get;
    }
  }

  #getByFetch(url, json = true) {
    return (async () => {
      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'User-Agent': 'Mozilla/5.0'
          }
        });

        if (!response.ok) {
          throw new Error(`Erro na requisição: ${response.status}`);
        }

        if (json) {
          return await response.json();
        } else {
          return await response.text();
        }
      } catch (error) {
        console.error('Erro ao buscar IP:', error);
        return null;
      }
    })();
  }

}

const get = new Get();
export default get;
